import { isTouchDevice, getScrollPosition } from '../utils/dom';
import { elements, state, isDesktop, DROPDOWN_CLOSE_DELAY } from './config';

export function hideNavbarDropdown(): void {
    if (elements.navbarDropdowns) {
        elements.navbarDropdowns.forEach(dropdown => {
            dropdown.classList.remove('visible');
            dropdown.setAttribute('aria-hidden', 'true');
        });
    }

    document.querySelectorAll('.nav-link.opened').forEach(link => {
        link.classList.remove('opened');
        link.setAttribute('aria-expanded', 'false');
    });

    if (getScrollPosition() === 0 && elements.navbar) {
        elements.navbar.classList.remove('mp-navbar-shadow');
    }
}

export function openDropdown(id: string | null): void {
    if (!id) {
        return;
    }

    if (isDesktop()) {
        clearTimeout(state.dropdownTimer ?? undefined);
    }

    hideNavbarDropdown();

    if (elements.navbar) {
        elements.navbar.classList.add('mp-navbar-shadow');
    }

    const targetDropdown = document.getElementById('mp-navbar-dropdown-' + id);

    if (targetDropdown) {
        targetDropdown.classList.add('visible');
        targetDropdown.setAttribute('aria-hidden', 'false');
    }

    if (elements.mobileSidebar) {
        elements.mobileSidebar.classList.add('opened-submenu');
    }
}

export function scheduleDropdownClose(): void {
    if (isDesktop()) {
        state.dropdownTimer = setTimeout(hideNavbarDropdown, DROPDOWN_CLOSE_DELAY);
    }
}

export function cancelDropdownClose(): void {
    if (isDesktop()) {
        clearTimeout(state.dropdownTimer ?? undefined);
    }
}

export function handleNavLinkClick(e: Event): void {
    const navLink = e.currentTarget as HTMLElement;

    if (isTouchDevice() || !isDesktop()) {
        const id = navLink.getAttribute('data-toggle-navbar-dropdown');
        
        if (!id) {
            return;
        }
        
        const dropdown = document.getElementById('mp-navbar-dropdown-' + id);

        if (dropdown?.classList.contains('visible')) {
            hideNavbarDropdown();
        } else {
            openDropdown(id);
            navLink.classList.add('opened');
            navLink.setAttribute('aria-expanded', 'true');
        }
    }
}

export function handleNavLinkMouseEnter(e: Event): void {
    if (!isTouchDevice() && isDesktop()) {
        const navLink = e.currentTarget as HTMLElement;
        openDropdown(navLink.getAttribute('data-toggle-navbar-dropdown'));
        navLink.classList.add('opened');
        navLink.setAttribute('aria-expanded', 'true');
    }
}

export function handleNavLinkMouseLeave(): void {
    scheduleDropdownClose();
}

export function initDropdown(): void {
    document.querySelectorAll('.nav-link').forEach(navLink => {
        navLink.addEventListener('click', handleNavLinkClick);
        navLink.addEventListener('mouseenter', handleNavLinkMouseEnter);
        navLink.addEventListener('mouseleave', handleNavLinkMouseLeave);
    });

    if (elements.navbarDropdowns) {
        elements.navbarDropdowns.forEach(dropdown => {
            dropdown.addEventListener('mouseenter', cancelDropdownClose);
            dropdown.addEventListener('mouseleave', scheduleDropdownClose);
            dropdown.setAttribute('aria-hidden', 'true');
        });
    }
}